// @flow
import * as React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import axios from "axios";
import Cookies from "js-cookie";
import {Api, BASE_URL} from "./Api/Api";
import {useDispatch} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import {logoutStatic} from "../../StateManagement/authSlice";

type
Props = {

};
export const Features = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [featuresList, setFeaturesList] = useState([])


    const fetchdata = async () => {
        try {
            const response = await axios.post(BASE_URL, {},{
                headers: {
                    "Content-type": "application/json",
                    'Accept': 'application/json',
                    "cmd": "getfeatures",
                },
            });
            if (response.status === 200) {
                const data = await response;
                setFeaturesList(data?.data?.dt?.sort((a,b) => a.sort - b.sort));
            } else {
                console.error(`API request failed with status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error while fetching menu data:", error);
        }
    }
    useEffect(() => {
        fetchdata()
    }, []);
    return (
        <div className="row justify-content-center mt-5 text-center">
                    {featuresList?.map((feature)=>{
                        return(
            <div className={`col-6 col-lg-3 ${feature?.Fstatus === 0 ? 'd-none': ''}`} key={feature?.FId}>
                <div className="card shadow">
                            <div className="card-body" key={feature.FId}>
                                <Link to={feature?.Flink} className="hovermenu text-primary text-decoration-none">
                                    <FontAwesomeIcon icon={feature.Ficon}/>
                                    <h5 className="mt-2">{feature.Ftitle}
                                    </h5>
                                </Link>
                            </div>
                </div>
            </div>
                        )
                    })}
        </div>
    );
};